<div class="notifications-container">
    <div class="notifications">
        <frms-notification *ngFor="let notifyItem of notifications "
            [notification]="notifyItem"
            ></frms-notification>
    </div>
</div>